import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=8b62fe7a&scoped=true&"
import script from "./Story.vue?vue&type=script&lang=ts&"
export * from "./Story.vue?vue&type=script&lang=ts&"
import style0 from "./Story.vue?vue&type=style&index=0&id=8b62fe7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b62fe7a",
  null
  
)

export default component.exports